import { render, staticRenderFns } from "./starComponents.vue?vue&type=template&id=d521739c&scoped=true&lang=pug&"
import script from "./starComponents.vue?vue&type=script&lang=js&"
export * from "./starComponents.vue?vue&type=script&lang=js&"
import style0 from "./starComponents.vue?vue&type=style&index=0&id=d521739c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d521739c",
  null
  
)

export default component.exports